import type { SVGProps } from 'react';

const SvgSignalWifiStatusbarConnectedNoInternet4 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M19 18h2v2h-2zm0-8h2v6h-2z" />
    <path d="M12 4C7.31 4 3.07 5.9 0 8.98L12 21l5-5.01V8h5.92C19.97 5.51 16.16 4 12 4" />
  </svg>
);
export default SvgSignalWifiStatusbarConnectedNoInternet4;
